// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forget-password-container {
  min-height: calc(100vh - 62px);
  max-width: 690px;
}
.forget-password-container .avatar {
  width: 100%;
  border-radius: 0;
  background: none;
  margin-bottom: 56px;
}
@media (min-width: 768px) {
  .forget-password-container .avatar {
    margin-bottom: 95px;
  }
}
.forget-password-container .forget-password-wrapper {
  width: 50%;
}
.forget-password-container .forget-password-form {
  width: 100%;
  max-width: 100%;
}
.forget-password-container .forget-password-form .login-field {
  margin: 0;
}
.forget-password-container .forget-password-form .login-field:nth-child(2) {
  margin: 15px 0;
}
.forget-password-container .forget-password-form .login-field label {
  font-size: 19px;
  line-height: 25px;
}
.forget-password-container .forget-password-form .login-field input {
  padding: 13px 0;
}
.forget-password-container .forget-password-form .mui-checkbox {
  width: 100%;
}
.forget-password-container .forget-password-form .submit-btn {
  font-size: 19px;
  width: 100%;
  margin-top: 40px;
}
@media (min-width: 768px) {
  .forget-password-container .forget-password-form .submit-btn {
    margin-top: 100px;
  }
}
.forget-password-container .forget-password-form .form-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.forget-password-container .forget-password-form .form-links .MuiGrid-item {
  width: 100%;
}
@media (min-width: 480px) {
  .forget-password-container .forget-password-form .form-links .MuiGrid-item {
    width: 50%;
  }
  .forget-password-container .forget-password-form .form-links .MuiGrid-item.signup-link {
    text-align: right;
  }
}
.forget-password-container .forget-password-form .form-links .MuiGrid-item a:hover {
  color: var(--color-yellow) !important;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/forget-password/ForgetPassword.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,gBAAA;AACJ;AAAI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAER;AADQ;EALJ;IAMQ,mBAAA;EAIV;AACF;AAFI;EACI,UAAA;AAIR;AAFI;EACI,WAAA;EACA,eAAA;AAIR;AAHQ;EACI,SAAA;AAKZ;AAJY;EACI,cAAA;AAMhB;AAJY;EACI,eAAA;EACA,iBAAA;AAMhB;AAJY;EACI,eAAA;AAMhB;AAHQ;EACI,WAAA;AAKZ;AAHQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AAKZ;AAJY;EAJJ;IAKQ,iBAAA;EAOd;AACF;AALQ;EACI,aAAA;EACA,eAAA;EACA,8BAAA;AAOZ;AANY;EACI,WAAA;AAQhB;AAPgB;EAFJ;IAGQ,UAAA;EAUlB;EATkB;IACI,iBAAA;EAWtB;AACF;AARoB;EACI,qCAAA;EACA,qBAAA;AAUxB","sourcesContent":[".forget-password-container{\n    min-height: calc( 100vh - 62px );\n    max-width: 690px;\n    .avatar{\n        width: 100%;\n        border-radius: 0;\n        background: none;\n        margin-bottom: 56px;\n        @media (min-width : 768px ){\n            margin-bottom: 95px;\n        }\n    }\n    .forget-password-wrapper {\n        width: 50%;\n    }\n    .forget-password-form{\n        width: 100%;\n        max-width: 100%;\n        .login-field{\n            margin: 0;\n            &:nth-child(2){\n                margin: 15px 0;\n            }\n            label{\n                font-size: 19px;\n                line-height: 25px;\n            }\n            input{\n                padding: 13px 0;\n            }\n        }\n        .mui-checkbox{\n            width: 100%;\n        }\n        .submit-btn{\n            font-size: 19px;\n            width: 100%;\n            margin-top: 40px;\n            @media (min-width : 768px ){\n                margin-top: 100px;\n            }\n        }\n        .form-links{\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            .MuiGrid-item{\n                width: 100%;\n                @media (min-width : 480px ){\n                    width: 50%;\n                    &.signup-link{\n                        text-align: right;\n                    }\n                }\n                a{\n                    &:hover{\n                        color: var(--color-yellow) !important;\n                        text-decoration: none;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
